import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnderwritingDecision = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "underwritingDecision",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13121",
			"data-name": "Path 13121",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13122",
			"data-name": "Path 13122",
			d: "M17.178,12.474a3.326,3.326,0,1,1-4.7,0,3.326,3.326,0,0,1,4.7,0",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13123",
			"data-name": "Path 13123",
			d: "M20,20l-2.82-2.82",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13124",
			"data-name": "Path 13124",
			d: "M11,21H6a2,2,0,0,1-2-2V5A2,2,0,0,1,6,3H17a2,2,0,0,1,2,2V9",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgUnderwritingDecision;
